export const APICONSTANT = {
  PAYMENT: 'payment-card',
  SUBSCRIBERESULT: 'subscribe-result'
}
